import React, { useEffect } from 'react'
import { TextField, Row, Column, Button } from 'quantic'
import { useForm } from 'react-hook-form'
import NotAuthenticatedLayout from 'components/templates/Layout/NotAuthenticated'
import { useParams, useHistory } from 'react-router-dom'
import { Title } from './styles'

function AccountConfirmation() {
  const { register, handleSubmit, errors } = useForm()

  const { push } = useHistory()
  const { email } = useParams()

  const onRequestEmail = async (emailToSendCode) => emailToSendCode

  useEffect(() => {
    if (email) onRequestEmail(email)
  }, [email])

  if (!email) {
    return (
      <NotAuthenticatedLayout>
        <form key="email" onSubmit={handleSubmit((fields) => push(`/validar-conta/${fields.email}`))}>
          <Row>
            <Column size={12}>
              <Title>Confirmar e-mail</Title>
            </Column>
            <Column size={12}>
              <TextField
                ref={register({ required: 'Campo obrigatório' })}
                name="email"
                label="E-mail"
                error={errors.email?.message}
                fullWidth
              />
            </Column>
            <Column size={12}>
              <Button primary fullWidth type="submit">
                Confirmar
              </Button>
            </Column>
          </Row>
        </form>
      </NotAuthenticatedLayout>
    )
  }

  return (
    <NotAuthenticatedLayout>
      <form key="code" onSubmit={handleSubmit(() => null)}>
        <Row>
          <Column size={12}>
            <Title>Confirmar e-mail</Title>
          </Column>
          <Column size={12}>
            <TextField
              ref={register({ required: 'Campo obrigatório' })}
              name="code"
              label="Código de Confirmação"
              error={errors.code?.message}
              fullWidth
            />
          </Column>
          <Column size={12}>
            <Button primary fullWidth type="submit">
              Confirmar
            </Button>
          </Column>
        </Row>
      </form>
    </NotAuthenticatedLayout>
  )
}

export default AccountConfirmation
